import arDesktop from 'images/pageAssets/ar_desktop.jpg';
import arMobile from 'images/pageAssets/ar_mobile.jpg';
import daDesktop from 'images/pageAssets/da_desktop.jpg';
import daMobile from 'images/pageAssets/da_mobile.jpg';
import deDesktop from 'images/pageAssets/de_desktop.jpg';
import deMobile from 'images/pageAssets/de_mobile.jpg';
import elDesktop from 'images/pageAssets/el_desktop.jpg';
import elMobile from 'images/pageAssets/el_mobile.jpg';
import enDesktop from 'images/pageAssets/en_desktop.jpg';
import enMobile from 'images/pageAssets/en_mobile.jpg';
import enUsDesktop from 'images/pageAssets/en-us_desktop.jpg';
import enUsMobile from 'images/pageAssets/en-us_mobile.jpg';
import esDesktop from 'images/pageAssets/es_desktop.jpg';
import esMobile from 'images/pageAssets/es_mobile.jpg';
import faDesktop from 'images/pageAssets/fa_desktop.jpg';
import faMobile from 'images/pageAssets/fa_mobile.jpg';
import frDesktop from 'images/pageAssets/fr_desktop.jpg';
import frMobile from 'images/pageAssets/fr_mobile.jpg';
import heDesktop from 'images/pageAssets/he_desktop.jpg';
import heMobile from 'images/pageAssets/he_mobile.jpg';
import hiDesktop from 'images/pageAssets/hi_desktop.jpg';
import hiMobile from 'images/pageAssets/hi_mobile.jpg';
import idDesktop from 'images/pageAssets/id_desktop.jpg';
import idMobile from 'images/pageAssets/id_mobile.jpg';
import isDesktop from 'images/pageAssets/is_desktop.jpg';
import isMobile from 'images/pageAssets/is_mobile.jpg';
import itDesktop from 'images/pageAssets/it_desktop.jpg';
import itMobile from 'images/pageAssets/it_mobile.jpg';
import jpDesktop from 'images/pageAssets/jp_desktop.jpg';
import jpMobile from 'images/pageAssets/jp_mobile.jpg';
import koDesktop from 'images/pageAssets/ko_desktop.jpg';
import koMobile from 'images/pageAssets/ko_mobile.jpg';
import mnDesktop from 'images/pageAssets/mn_desktop.jpg';
import mnMobile from 'images/pageAssets/mn_mobile.jpg';
import nlDesktop from 'images/pageAssets/nl_desktop.jpg';
import nlMobile from 'images/pageAssets/nl_mobile.jpg';
import noDesktop from 'images/pageAssets/no_desktop.jpg';
import noMobile from 'images/pageAssets/no_mobile.jpg';
import plDesktop from 'images/pageAssets/pl_desktop.jpg';
import plMobile from 'images/pageAssets/pl_mobile.jpg';
import ptDesktop from 'images/pageAssets/pt_desktop.jpg';
import ptMobile from 'images/pageAssets/pt_mobile.jpg';
import ruDesktop from 'images/pageAssets/ru_desktop.jpg';
import ruMobile from 'images/pageAssets/ru_mobile.jpg';
import slDesktop from 'images/pageAssets/sl_desktop.jpg';
import slMobile from 'images/pageAssets/sl_mobile.jpg';
import svDesktop from 'images/pageAssets/sv_desktop.jpg';
import svMobile from 'images/pageAssets/sv_mobile.jpg';
import swDesktop from 'images/pageAssets/sw_desktop.jpg';
import swMobile from 'images/pageAssets/sw_mobile.jpg';
import thDesktop from 'images/pageAssets/th_desktop.jpg';
import thMobile from 'images/pageAssets/th_mobile.jpg';
import trDesktop from 'images/pageAssets/tr_desktop.jpg';
import trMobile from 'images/pageAssets/tr_mobile.jpg';
import ukDesktop from 'images/pageAssets/uk_desktop.jpg';
import ukMobile from 'images/pageAssets/uk_mobile.jpg';
import yoDesktop from 'images/pageAssets/yo_desktop.jpg';
import yoMobile from 'images/pageAssets/yo_mobile.jpg';
import zhCnDesktop from 'images/pageAssets/zh-cn_desktop.jpg';
import zhCnMobile from 'images/pageAssets/zh-cn_mobile.jpg';

const languageMap: Record<string, string | undefined> = {
  ar_desktop: arDesktop,
  ar_mobile: arMobile,
  da_desktop: daDesktop,
  da_mobile: daMobile,
  de_desktop: deDesktop,
  de_mobile: deMobile,
  el_desktop: elDesktop,
  el_mobile: elMobile,
  en_desktop: enDesktop,
  en_mobile: enMobile,
  'en-us_desktop': enUsDesktop,
  'en-us_mobile': enUsMobile,
  es_desktop: esDesktop,
  es_mobile: esMobile,
  fa_desktop: faDesktop,
  fa_mobile: faMobile,
  'es-mx_desktop': esDesktop,
  'es-mx_mobilex': esMobile,
  fr_desktop: frDesktop,
  fr_mobile: frMobile,
  he_desktop: heDesktop,
  he_mobile: heMobile,
  hi_desktop: hiDesktop,
  hi_mobile: hiMobile,
  id_desktop: idDesktop,
  id_mobile: idMobile,
  is_desktop: isDesktop,
  is_mobile: isMobile,
  it_desktop: itDesktop,
  it_mobile: itMobile,
  'jp-full_desktop': jpDesktop,
  'jp-full_mobile': jpMobile,
  'jp-romaji_desktop': jpDesktop,
  'jp-romaji_mobile': jpMobile,
  ko_desktop: koDesktop,
  ko_mobile: koMobile,
  mn_desktop: mnDesktop,
  mn_mobile: mnMobile,
  nl_desktop: nlDesktop,
  nl_mobile: nlMobile,
  no_desktop: noDesktop,
  no_mobile: noMobile,
  pl_desktop: plDesktop,
  pl_mobile: plMobile,
  pt_desktop: ptDesktop,
  pt_mobile: ptMobile,
  'pt-br_desktop': ptDesktop,
  'pt-br_mobile': ptMobile,
  ru_desktop: ruDesktop,
  ru_mobile: ruMobile,
  sl_desktop: slDesktop,
  sl_mobile: slMobile,
  sv_desktop: svDesktop,
  sv_mobile: svMobile,
  sw_desktop: swDesktop,
  sw_mobile: swMobile,
  th_desktop: thDesktop,
  th_mobile: thMobile,
  tr_desktop: trDesktop,
  tr_mobile: trMobile,
  uk_desktop: ukDesktop,
  uk_mobile: ukMobile,
  yo_desktop: yoDesktop,
  yo_mobile: yoMobile,
  'zh-cn_desktop': zhCnDesktop,
  'zh-cn_mobile': zhCnMobile,
};

export function getLocaleBackgroundImage(
  format: 'desktop' | 'mobile',
  languageLocale: string,
): string | undefined {
  return languageMap[`${languageLocale}_${format}`];
}
